import { observable, action, runInAction } from 'mobx'
import BaseStore from '@store/table'
import Api from '@api/xiu_yan/relatedCasesApi'
import moment from 'moment'
import { Modal, message } from 'hljd'
const confirm = Modal.confirm

class Store extends BaseStore {
  set_meal_id

  $listApi = Api.relative_examples
  $getParams = () => {
    const { set_meal_id } = this
    return {
      set_meal_id
    }
  }

  @observable useExample = []
  @action
  getExampleUse = () => {
    const { $list } = this
    this.useExample = $list.map(({ example_id }) => example_id)
  }

  @observable info = {}
  @action
  getDetails = async () => {
    const { set_meal_id } = this
    let {
      data: { work }
    } = await Api.package_details({ id: set_meal_id })
    runInAction(() => {
      this.info = work || {}
    })
  }

  @action
  delCase = example_ids => () => {
    confirm({
      title: '你是否确认移除该案例？',
      onOk: async () => {
        const { set_meal_id } = this
        let { success } = await Api.del_relative_example({
          example_ids,
          set_meal_id
        })
        if (success) {
          message.success('操作成功！')
          this.$getList(1)
        }
      }
    })
  }

  @observable shooting_time = null
  @observable mark_content = ''
  @observable example_id = ''

  @observable markVisible = false
  @action
  showMark = (mark_content, example_id, shooting_time) => () => {
    this.markVisible = true
    this.mark_content = mark_content
    this.shooting_time = moment(shooting_time)
    this.example_id = example_id
  }

  @action
  editMark = value => {
    this.mark_content = value
  }

  @observable timeVisible = false
  @action
  showTime = (mark_content, example_id, shooting_time) => () => {
    this.timeVisible = true
    this.mark_content = mark_content
    this.shooting_time = moment(shooting_time)
    this.example_id = example_id
  }

  @action
  editTime = value => {
    this.shooting_time = value
  }

  @action
  doCancel = () => {
    this.mark_content = ''
    this.shooting_time = null
    this.example_id = ''
  }

  @action
  hideMark = () => {
    this.markVisible = false
    this.doCancel()
  }

  @action
  hideTime = () => {
    this.timeVisible = false
    this.doCancel()
  }

  @action
  doChange = value => async () => {
    const { mark_content, example_id, shooting_time } = this
    let params = {
      mark_content,
      example_id,
      shooting_time: shooting_time.format(__FMT1__)
    }
    let { success } = await Api.update_relative_example(params)
    if (success) {
      message.success('操作成功！')
      if (value == 'mark') {
        this.hideMark()
      } else {
        this.hideTime()
      }
      this.$getList(1)
    }
  }
}
export default new Store()
